export default "__VITE_ASSET__Df0CHwW___"